var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 102.4C0 45.846 45.846 0 102.4 0H409.6C466.154 0 512 45.846 512 102.4V409.6C512 466.154 466.154 512 409.6 512H102.4C45.846 512 0 466.154 0 409.6V102.4Z",
    fill: "url(#paint0_linear_5_6)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M248.733 332C248.542 332 248.347 331.996 248.152 331.991C242.449 331.825 237.069 329.243 233.269 324.86L179.276 262.511C171.644 253.697 172.378 240.166 180.919 232.289C189.459 224.404 202.571 225.171 210.203 233.985L249.575 279.45L379.599 145.267C387.691 136.911 400.832 136.911 408.924 145.267C417.025 153.627 417.025 167.18 408.924 175.536L263.396 325.729C259.501 329.753 254.224 332 248.733 332Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M256.5 448C153.664 448 70 361.869 70 256C70 150.131 153.664 64 256.5 64C290.613 64 323.996 73.5744 353.032 91.6949C362.822 97.8005 365.946 110.916 360.02 120.994C354.085 131.072 341.345 134.293 331.556 128.183C308.994 114.108 283.037 106.667 256.5 106.667C176.516 106.667 111.444 173.658 111.444 256C111.444 338.342 176.516 405.333 256.5 405.333C336.484 405.333 401.556 338.342 401.556 256C401.556 249.655 401.162 243.255 400.395 236.979C398.953 225.289 406.993 214.613 418.349 213.133C429.705 211.644 440.07 219.93 441.508 231.616C442.499 239.667 443 247.868 443 256C443 361.869 359.336 448 256.5 448Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_6",
    x1: 0,
    y1: 0,
    x2: 512,
    y2: 512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A8CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.579102,
    stopColor: "#0F59D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003389"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.5ef30abc0394303938684294b49373b9.svg";
export { ForwardRef as ReactComponent };